import React, { useRef, useState } from 'react';
import { MediaView } from 'common';
import { stylesheet } from 'typestyle';

interface IProps {
  onError?: () => any
  onLoad?: () => void
  src?: string
  media?: MediaView
  onClick?: () => void
  style?: React.CSSProperties
}

export function MediaImage({ onError, onLoad, src, style }: IProps) {
  const [error, setError] = useState<boolean | null>(null);
  const divRef = useRef<HTMLDivElement>(null);

  function handleError() {
    setError(true);
    if (onError) {
      onError();
    }
  }

  function handleLoad() {
    if (onLoad) {
      onLoad();
    }
  }

  if (error) {
    return null;
  }

  return (
    <div style={{ position: 'relative' }} ref={divRef}>
      <img
        className={sheet.image}
        style={{ ...style }}
        src={src}
        onLoad={handleLoad}
        onError={handleError}
      />
    </div>
  );
}

const sheet = stylesheet({
  image: {
    display: 'block',
  },
});
